/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Pipe, PipeTransform} from '@angular/core';
import {ReferenceDataModel} from '../../../api/reference-data.model';

@Pipe({
    name: 'prettyPrintReference',
    standalone: false
})
export class PrettyPrintReferencePipe implements PipeTransform {

    transform(reference: ReferenceDataModel, removeCode?: boolean, removeName?: boolean): string {
        if (removeCode) {
            return reference ? reference.name : null;
        }
        if (removeName) {
            return reference ? reference.code : null;
        } else {
            return reference ? `${reference.code} - ${reference.name}` : null;
        }
    }
}
